import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, ButtonType } from '../../components/Button'
import {
  MainRouteName,
  OrdersChildName,
  useAccountRouter,
} from '../../hooks/useAccountRouter'
import { CleanOrderStatus, ReviewStatus } from '../../graphql-types'
import { useMarketplace } from '../../hooks/useMarketplace'
import { singleOrderCustomType } from './queries/getSingleOrderCustomType'
import { useTranslation } from 'react-i18next'
import { convertToSlug } from '@src/utils/convertToSlug'
import styled from 'styled-components'

const ReviewSectionContainer = styled.div`
  padding: 0 16px 16px;
`

const ReviewMessage = styled.p`
  margin: 0;
  padding: 14px;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  color: #6f6f6f;
  background: #f6f6f9;
  border-radius: 8px;
`

export const OrderReviewSection: React.FC<{
  myOrder: singleOrderCustomType
}> = ({ myOrder }) => {
  const { t } = useTranslation('singleOrder')
  const { allowReviews, urlPath } = useMarketplace()
  const canReview =
    allowReviews && myOrder.cleanOrderStatus === CleanOrderStatus.COMPLETE
  const { setRoute } = useAccountRouter()
  const navigate = useNavigate()

  const hasReviewed = !!myOrder.review
  const reviewApproved = myOrder.review?.status === ReviewStatus.APPROVED

  const handleViewReviews = () => {
    const outlet = myOrder.outlet
    if (outlet) {
      const outletPath = `/${urlPath}/${outlet.id}/${convertToSlug(
        outlet.displayName
      )}/menu`
      navigate({
        pathname: outletPath,
        search: 'showReviews=1',
      })
    }
  }

  return (
    <ReviewSectionContainer>
      {hasReviewed ? (
        reviewApproved ? (
          <Button
            buttonType={ButtonType.TERTIARY}
            content={t('review_view_reviews')}
            onClick={handleViewReviews}
          />
        ) : (
          <ReviewMessage>{t('review_thank_you_pending')}</ReviewMessage>
        )
      ) : canReview ? (
        <Button
          buttonType={ButtonType.SECONDARY}
          content={t('review_order_button')}
          onClick={() =>
            setRoute({
              mainRouteName: MainRouteName.ORDERS,
              childRouteName: OrdersChildName.REVIEW,
              pageDataId: myOrder.id,
            })
          }
        />
      ) : null}
    </ReviewSectionContainer>
  )
}
